/* eslint-disable no-useless-escape */
export const MIN_AGE = 18;

// Local storage keys - valori che vengono salvati nel localStorage per il funzionamento dell'applicazione
export const LOCALSTORAGE_USER_DATA = 'userData';
export const LOCALSTORAGE_PERSONIFIED_USER = 'personifiedUser';
export const LOCALSTORAGE_TOKEN_DATA = 'tokenData';
export const LOCALSTORAGE_LANGUAGE = 'language';
export const LOCALSTORAGE_CODE_VERIFIER = 'codeVerifier';
export const LOCALSTORAGE_CURRENT_SITE_ID = 'currentSite';
export const LOCALSTORAGE_RETURN_URL = 'returnUrl';
export const LOCALSTORAGE_TECHNICIAN_ID = 'technicianId';
export const LOCALSTORAGE_NOTIFICATION_MAINTENANCE_ID = 'notificationMaintenanceId';
export const LOCALSTORAGE_BETA_FE = 'betaFE';

// Application IDs - valori che vengono usati per identificare l'applicazione
export const APPLICATION_ID = 'frontend';
export const PRIVACY_APPLICATION_ID = 'fe-privacy';

// Regex validazione form - valori che vengono usati per validare i valori inseriti dall'utente
export const USERNAME_REGEXP = '^[a-zA-Z0-9\.@\-_]{5,15}$';
export const PASSWORD_REGEXP = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9@!$%&]{8,64}$';
export const PHONE_REGEXP = '^[0-9\-\+]{5,64}$';
// export const EMAIL_REGEXP = '/^(?=.{1,254}$)(?=.{1,64}@)[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]{1,63}\.)+[A-Za-z]{2,63}$/'; // too much strenght

// Routing default - valori che determinano il routing default dell'applicazione, quindi la pagina in cui atterra l'utente una volta loggato
export const ROUTE_IMPERS_DEFAULT = ['/impers', 'sites'];
export const ROUTE_USER_DEFAULT = ['/home', 'sites'];
export const ROUTE_TECHNICIAN_DEFAULT = ['/technician', 'support'];
export const ROUTE_SERVICE_DEFAULT = ['/came-service', 'keycodes'];
export const ROUTE_SUBSIDIARY_DEFAULT = ['/came-subsidiary', 'keycodes'];
export const ROUTE_DEFAULT = ['/home', 'sites']; // per default viene rediretto l'utente alla pagina delle siti
export const ROUTE_MARKETING_DEFAULT = ['/came-marketing', 'helperController']; // per il marketing viene rediretto l'utente alla pagina delle chiavi di supporto
// Landing page dopo login per utenti con ruolo FIRM_TECH (gestione firmware/software updates).
export const ROUTE_FIRM_TECH_DEFAULT = ['/firm-tech', 'software-updates'];

// Theme names - valori che vengono usati per il nome dei temi dell'applicazione
export const THEME_CAME_CLASSIC_NAME = 'came-classic';
export const THEME_CAME_CLASSIC_CSS = 'came';
export const THEME_CAME_NEW_NAME = 'came-new';
export const THEME_CAME_NEW_CSS = 'dim';
